exports.components = {
  "component---src-components-concept-jsx": () => import("./../../../src/components/Concept.jsx" /* webpackChunkName: "component---src-components-concept-jsx" */),
  "component---src-components-concept-scheme-jsx": () => import("./../../../src/components/ConceptScheme.jsx" /* webpackChunkName: "component---src-components-concept-scheme-jsx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

